import { differenceInHours } from 'lib/helpers/dateUtils';

/**
 * Color variant for sidebar secondary text (due dates & working sessions),
 * rendered by `StepDescription` in xs text:
 * - 'danger' (red) — within 24h of the date, due, or past due
 * - 'warning' (orange) — within 48h of the date
 * - 'default' (grey) — otherwise
 *
 * @param {Date} date - Parsed due date / session start.
 * @returns {'default'|'warning'|'danger'}
 */
export const getDueDateVariant = (date) => {
  const hours = differenceInHours(date, new Date());
  return hours <= 24 ? 'danger' : hours <= 48 ? 'warning' : 'default';
};
